module.exports = __webpack_public_path__ + "img/flamethrower-turret-base-west.301f1c31.png";